<template>
  <div class="card">
    <div>
      <div class="table-header-div">
        <div class="upcomingmeeting-heading-div">
          <h3 class="upcomingmeeting-div">Upcoming Meetings</h3>
        </div>
        <div class="number-of-records-div"><span class="number-of-records-span">{{
          displayUniqueUpcomingMeetings.length
        }}</span></div>
      </div>
      <DataTable v-if="!displayUniqueUpcomingMeetings?.length" :value="[]">
        <template #empty>
          No Upcoming Meetings
        </template>
        <Column field="date" header="DATE" header-class="header-style-class"
          body-class="body-style-class"></Column>
        <Column field="tb_name" header="MEETING" header-class="header-style-class"
          body-class="body-style-class">></Column>
      </DataTable>
      <DataTable v-else v-model:selection="selectedMeeting" :value="displayUniqueUpcomingMeetings" selectionMode="single"
        dataKey="id" :metaKeySelection="false" @rowSelect="onRowSelect" tableStyle="min-width: 10rem" rows="7" paginator>
        <Column field="date" header="DATE" sortable header-class="header-style-class"
          body-class="body-style-class">
          <template #body="{ data }">
            {{ moment(String(data.date)).format('MM/DD/YY') }} {{ data.start_time }}
          </template>
        </Column>
        <Column field="tb_name" header="MEETING" sortable header-class="header-style-class"
          body-class="body-style-class"></Column>
      </DataTable>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { ref, onMounted } from 'vue'
import { getScheduledPatients } from './getScheduledPatients.js'
import { getPatientDetailsByMRN } from './getPatientDetailsByMRN.js'
import { getRequestingPhysicians } from './getRequestingPhysicians.js'
import { mergeByMrn, mergeByPhysicianId } from '@/utils/utils.js'
import { useStore } from 'vuex'
import moment from 'moment'

const store = useStore()
const scheduledPatients = ref([])
const patientDetailsByMRN = ref([])
const requestingPhysician = ref([])
const upcomingMeetings = ref([])
const selectedMeeting = ref()
const displayUniqueUpcomingMeetings = ref([])

onMounted(async () => {
  const scheduledPatientFromResponse = await getScheduledPatients()
  scheduledPatients.value = scheduledPatientFromResponse
  const requestingPhysicianFromResponse = await getRequestingPhysicians()
  requestingPhysician.value = requestingPhysicianFromResponse

  const mrnList = scheduledPatients.value && scheduledPatients.value.map((item) => item.mrn)
  if (mrnList) {
    const patientDetailsByMRNFromResponse = await getPatientDetailsByMRN(mrnList)
    patientDetailsByMRN.value = patientDetailsByMRNFromResponse
  }
  upcomingMeetings.value = groupDataByObjectProperty(tableDataWithMRNPhysicianDetails())
  displayUniqueUpcomingMeetings.value = getUniqueUpcomingValues(upcomingMeetings.value)
  console.log(upcomingMeetings.value)
  store.dispatch('setUpcomingMeetings', { upcomingMeetings, publish: true })
})

const onRowSelect = (meeting) => {
  const isMeetingClicked = true
  store.dispatch('setSessionMeeting', { meeting, publish: true })
  store.dispatch('setUpcomingMeetingClicked', { isMeetingClicked, publish: true })
}

const groupDataByObjectProperty = (array) => {
  const filteredByRequestingPhysicianData = array.filter(
    (obj) =>
      obj.caregiver_name &&
      obj.caregiver_name.includes(store.state.profile.displayName)
  )
  const sortedPatientData =
    filteredByRequestingPhysicianData &&
    filteredByRequestingPhysicianData.sort((a, b) => (a.date > b.date ? 1 : b.date > a.date ? -1 : 0))
  const scheduledPatientsGrouped = Object.values(
    sortedPatientData.reduce((acc, current) => {
      acc[current.date] ??= []
      acc[current.date].push(current)
      return acc
    }, {})
  )

  const result = []
  scheduledPatientsGrouped.map((element) => {
    const resulset = Object.values(
      element.reduce((acc, current) => {
        acc[current.tb_id] ??= []
        acc[current.tb_id].push(current)
        return acc
      }, {})
    )
    result.push(resulset)
  })
  return result.flat()
}

const getUniqueUpcomingValues = (array) => {
  if (!array) { return [] }
  return array.map((gl) => gl[0])
}

const tableDataWithMRNPhysicianDetails = () => {
  let tableData = scheduledPatients.value
  if (scheduledPatients.value?.length && patientDetailsByMRN.value?.length) {
    tableData = mergeByMrn(scheduledPatients.value, patientDetailsByMRN.value)
  }
  if (scheduledPatients.value?.length && requestingPhysician.value?.length) {
    tableData = mergeByPhysicianId(tableData, requestingPhysician.value)
  }
  return tableData
}
</script>

<style lang="scss" scoped>
.table-header-div {
  display: flex;
  background-color: #ffffff;
}

.upcomingmeeting-heading-div {
  width: 85%;
  text-align: initial;
}

.upcomingmeeting-div {
  margin-left: 16px;
  font-size: 14px;
  font-weight: 600;
  margin-top: 6%;
}

.number-of-records-div {
  width: 15%;
  margin-top: 4%;
}
</style>

